
<div class="schedule-table" tabindex="0">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th class="date-header header fixed name-header" :style="{ backgroundColor: headerBcakgroungColor }">姓名</th>
          <th v-for="(day, index) in days" :key="index" class="date-header header"
            :style="{ backgroundColor: headerBcakgroungColor }">
            {{ day.month }}月{{ day.day }}日<br />
            {{ day.dayOfWeek }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(person, rowIndex) in uniquePersons" :key="person.employNo">
          <td class="fixed name-cell">
            <div
              style="border-top: 1px solid #ccc;height: 100%;display: flex;align-items: center;justify-content: center;">
              {{ person.employName }}
            </div>
          </td>
          <td v-for="(day, colIndex) in days" :key="colIndex" :class="getCellClass(rowIndex, colIndex)"
            @mousedown="startSelection(rowIndex, colIndex)" @mouseover="continueSelection(rowIndex, colIndex)"
            @mouseup="endSelection" @dblclick="activateEditor(rowIndex, colIndex)">

            <template v-if="editingCell && editingCell[0] === rowIndex && editingCell[1] === colIndex">
              <input @blur="handleBlur" placeholder="请输入" ref="myInput" type="text"
                style="text-align: center; width: 90%;" v-model="localValue[person.employNo][colIndex]">
            </template>
            <template v-else>
              <span :style="getCellStyle(localValue[person.employNo][colIndex])">
                {{ localValue[person.employNo][colIndex] }}
              </span>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
